module.exports = {"title":"Error","error":"You have been logged out of the stream.<br />Only one code can be used for one patron.","refresh":"Refresh"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Stream/StreamBootedModal/locales/fr.json
// module id = 1807
// module chunks = 0